import { Globe } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { usePublicCountry } from '@/contexts/PublicCountryContext';

/** Locked country label. Visitors stay on the country we detected from their location. */
export function PublicCountrySwitcher({ className = '' }: { className?: string }) {
  const { countries, countryId, country, canChangeCountry, setCountryId } = usePublicCountry();

  if (!canChangeCountry) {
    if (!country) {
      return null;
    }
    return (
      <div className={`flex items-center gap-2 min-w-0 text-sm text-muted-foreground ${className}`}>
        <Globe className="h-4 w-4 flex-shrink-0" />
        <span className="truncate">{country.name}</span>
      </div>
    );
  }

  if (countries.length === 0) {
    return null;
  }

  return (
    <div className={`flex items-center gap-2 min-w-[9rem] ${className}`}>
      <Globe className="h-4 w-4 text-muted-foreground flex-shrink-0" />
      <Select value={countryId || undefined} onValueChange={setCountryId}>
        <SelectTrigger className="h-9">
          <SelectValue placeholder="Select country" />
        </SelectTrigger>
        <SelectContent>
          {countries.map((item) => (
            <SelectItem key={item.id} value={item.id}>
              {item.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
